import { cn } from "@/lib/utils"

interface SubstepIndicatorProps {
  currentSubstep: number
  totalSubsteps: number
}

export function SubstepIndicator({
  currentSubstep,
  totalSubsteps,
}: SubstepIndicatorProps) {
  return (
    <div className="flex gap-2">
      {Array.from({ length: totalSubsteps }, (_, i) => (
        <div
          key={i}
          className={cn(
            "h-1 w-8 rounded-full transition-colors",
            i < currentSubstep ? "bg-primary" : "bg-muted/40",
          )}
        />
      ))}
    </div>
  )
}
